import RTButton from './button.scss'
import RTInput from './input.scss'
import RTList from './list.scss'
import RTCard from './card.scss'
import RTDropdown from './dropdown.scss'
import General from './general.scss'
import RTTabs from './tab.scss'
import RTCheckbox from './checkbox.scss'
import RTDatePicker from './calendar.scss'
import RTSwitch from './switch.scss'
import RTSlider from './slider.scss'
import RTLayout from './layout.scss'
export default {
  RTSlider, RTSwitch, General, RTDatePicker, RTCheckbox, RTTabs, RTButton, RTInput, RTList, RTCard, RTDropdown, RTLayout
}
